import { render, staticRenderFns } from "./BillingReport.vue?vue&type=template&id=6572d4b9&scoped=true"
import script from "./BillingReport.vue?vue&type=script&lang=js"
export * from "./BillingReport.vue?vue&type=script&lang=js"
import style0 from "./BillingReport.vue?vue&type=style&index=0&id=6572d4b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6572d4b9",
  null
  
)

export default component.exports